import { groupEntityName } from '../../../../../backend/features/groups/shared';
import { getGroupFilter } from '../../../../../backend/features/permissions/shared';
import { useUserState } from '../../../../../ui/hooks';
import { useContactManagementTranslation } from '../../../../../ui/hooks/useContactManagementTranslation';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { Box, Button, CircularProgress, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import React from 'react';
export const GroupManagement = (props) => {
    const { t } = useContactManagementTranslation();
    const userState = useUserState();
    const { data: groups, isLoading } = useStorageList(groupEntityName, {
        filter: [...getGroupFilter(userState), { column: 'filterBased', op: '=', value: false }, { op: 'in', id: props.groupIds }],
        orderBy: [{ column: 'name' }],
    });
    return (React.createElement(Paper, { sx: { p: 2, display: 'flex', flexDirection: 'column', gap: 1 }, variant: 'outlined' },
        React.createElement(Box, { sx: { pb: 2, display: 'flex', alignItems: 'center', gap: 2 } },
            React.createElement(Typography, { sx: { flexGrow: 1 }, variant: 'subtitle1' }, t('forms.accountGroupUser.groups')),
            React.createElement(Button, { startIcon: React.createElement(AddIcon, null), color: 'primary', onClick: props.onAddGroup }, t('forms.accountGroupUser.addGroup'))), groups === null || groups === void 0 ? void 0 :
        groups.rows.map((group) => (React.createElement(Box, { key: group.id, sx: {
                p: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                backgroundColor: themeColors.surface.secondary,
                borderRadius: 1,
            } },
            React.createElement(Typography, { sx: { flexGrow: 1 }, variant: 'subtitle2' }, group.columns.name),
            React.createElement(Tooltip, { title: t('forms.accountGroupUser.removeGroup') },
                React.createElement(IconButton, { color: 'primary', onClick: () => props.onRemoveGroup(group.id) },
                    React.createElement(DeleteOutlinedIcon, null)))))),
        !groups && isLoading && React.createElement(CircularProgress, null)));
};
